import { createActions } from 'redux-actions';
import { GET_PLANS, GET_RECORDS } from '../actionTypes';

export default createActions({
  [GET_PLANS]: (state) => {
    return state;
  },
  [GET_RECORDS]: (state) => {
    return state;
  }
});
